// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1hti2","footer":"ModalFilter_footer__olq4_"};